import React, { useState, useEffect } from 'react'
import List from './List'
import Alert from './Alert'

const getLocalStorage = () => {
    let list = localStorage.getItem('list')
    if (list) {
        return JSON.parse(list)
    } else {
        return []
    }
}

function App() {
    const [itemName, setItemName] = useState('')
    const [list, setList] = useState(getLocalStorage())
    const [isEditing, setIsEditing] = useState(false)
    const [editID, setEditID] = useState(null)
    const [alert, setAlert] = useState({
        show: false,
        msg: '',
        type: '',
    })

    const handleSubmit = (e) => {
        e.preventDefault()
        if (!itemName) {
            showAlert(true, 'danger', 'Please enter value for item')
        } else if (itemName && isEditing) {
            // deal with edit
            setList(
                list.map((item) => {
                    if (item.id === editID) {
                        return { ...item, title: itemName }
                    }
                    return item
                })
            )
            setItemName('')
            setEditID(null)
            setIsEditing(false)
            showAlert(true, 'success', 'Item Edited')
        } else {
            // show alert
            const newItem = {
                id: new Date().getTime().toString(),
                title: itemName,
            }
            setList([...list, newItem])
            setItemName('')
            showAlert(true, 'success', 'Item added to the list')
        }
    }

    const showAlert = (show = false, type = '', msg = '') => {
        setAlert({ show, type, msg })
    }

    const clearList = () => {
        showAlert(true, 'danger', 'Deleted all list items')
        setList([])
    }

    const removeItem = (id) => {
        showAlert(true, 'danger', 'Item removed')
        setList(list.filter((item) => item.id !== id))
    }

    const editItem = (id) => {
        const itemToEdit = list.find((item) => item.id === id)
        setIsEditing(true)
        setEditID(id)
        setItemName(itemToEdit.title)
    }

    useEffect(() => {
        localStorage.setItem('list', JSON.stringify(list))
    }, [list])

    return (
        <section className='section-center'>
            <form className='quick-list-form' onSubmit={handleSubmit}>
                {alert.show && (
                    <Alert {...alert} removeAlert={showAlert} list={list} />
                )}
                <h3>Quick List</h3>
                <div className='form-control'>
                    <input
                        type='text'
                        className='quick-list-input'
                        placeholder='e.g. Buy Milk'
                        value={itemName}
                        onChange={(e) => setItemName(e.target.value)}
                    />
                    <button type='submit' className='submit-btn'>
                        {isEditing ? 'Edit' : 'Submit'}
                    </button>
                </div>
            </form>
            {list.length > 0 && (
                <div className='quick-list-container'>
                    <List
                        items={list}
                        removeItem={removeItem}
                        editItem={editItem}
                    />
                    <button className='clear-btn' onClick={clearList}>
                        Clear Items
                    </button>
                </div>
            )}
        </section>
    )
}

export default App
